module.exports = __webpack_public_path__ + "img/likeHeader.a0c63222.png";